// Unlike bannerImage/sectionImage/cover (plain filename strings), a saved
// benefit's icon is always the {src, title} object pl-back's
// benefits.service.ts stores it as (see BenefitsDescription.icon: FileDto)
// - never a bare string, so it doesn't fit formatImage's string-vs-object
// branching. Mirrors the inline format() in the legacy BenefitsEdit page.
export const formatBenefitIcon = (value: any) => {
  if (!value) return [];
  if (typeof value.src === "string" && !value.rawFile)
    return [
      {
        src: `${window["location"]["protocol"]}//${window["env"]["apiDomain"]}/uploads/${value.src}`,
      },
    ];
  return value;
};
